import React, { Component } from "react"
import CalorieCalculator from "./components/CalorieCalculator"
import LayoutWrapper from "./components/shared/layoutWrapper/LayoutWrapper"
import CalorieResult from "./components/shared/calorieResut/CalorieResult"
import BmiHeaderSection from "../bmiCalculator/components/shared/bmiHeaderSection/BmiHeaderSection"
import CalorieCalculatorIcon from "../../assets/images/icon - calorie calculator.svg"
import CalorieCalculatorNewsletter from "./components/CalorieCalculatorNewsletter"
import addToMailchimp from "gatsby-plugin-mailchimp"
import CalorieFeaturesSection from "./components/shared/calorieFeaturesSection/CalorieFeaturesSection"
import LocaleContext from "../../context/LocaleContext"
import translate from "../../translation/translator"
import keys from "../../translation/keys"

class CalorieCalculatorContainer extends Component {
  constructor() {
    super()

    this.state = {
      units: "Metric",
      gender: "Female",
      weight: "75",
      height: "167",
      age: "32",
      dailyActivity: "standing",
      sliderValue: 1,
      showResults: false,
      locale: "path",
      email: "",
      error: "",
    }
  }

  componentDidMount() {
    let link = window.location.href

    const locale = link === "https://dianurse.netlify.app/" ? "bg" : "bg"
    this.setState({ locale })
  }

  handleChangeEmail = e => {
    this.setState({ email: e.target.value })
  }

  handleSubmit = async e => {
    e.preventDefault()
    await addToMailchimp(this.state.email).then(data => {
      if (data.result === "success") {
        this.setState({ error: "Успешно изпратен имейл." })
      }
      if (data.msg === "The email you entered is not valid.") {
        this.setState({ error: "Имейлът е невалиден." })
      }
      if (data.msg.includes("<")) {
        this.setState({ error: "Този имейл вече е използван." })
      }
      if (data.msg.includes("Recipient")) {
        this.setState({ error: "Този имейл вече е използван." })
      }
    })
    this.setState({ email: "" })
  }

  handleChangeUnits = e => {
    this.setState({
      units: e.target.value,
    })
  }

  handleChangeGender = e => {
    this.setState({
      gender: e.target.value,
    })
  }

  handleChangeAge = e => {
    this.setState({
      age: e.target.value,
    })
  }

  handleChangeSlider = sliderValue => {
    this.setState({ sliderValue: sliderValue })
  }

  handleChangeDailyActivity = e => {
    this.setState({ dailyActivity: e.target.value })
  }

  handleChangeWeight = e => {
    this.setState({ weight: e.target.value })
  }

  handleChangeHeight = e => {
    this.setState({ height: e.target.value })
  }

  handleShowResults = () => {
    this.setState({ showResults: true })
  }

  handleCloseResults = () => {
    this.setState({ showResults: false })
  }

  render() {
    const {
      units,
      gender,
      weight,
      age,
      dailyActivity,
      sliderValue,
      showResults,
      height,
      error,
      email,
    } = this.state
    const { locale } = this.context

    const subText = translate(keys.CAL_CALC_SUB_TEXT, locale)
    const text = translate(keys.CAL_CALC_TEXT, locale)
    const title = translate(keys.CAL_CALC_TITLE, locale)

    return (
      <React.Fragment>
        {showResults === false ? (
          <React.Fragment>
            <BmiHeaderSection
              locale={locale}
              subText={subText}
              text={text}
              icon={CalorieCalculatorIcon}
              title={title}
            />
            <CalorieFeaturesSection locale={locale} />
            <LayoutWrapper locale={locale}>
              <CalorieCalculator
                locale={locale}
                units={units}
                handleChangeUnits={this.handleChangeUnits}
                gender={gender}
                handleChangeGender={this.handleChangeGender}
                weight={weight}
                handleChangeWeight={this.handleChangeWeight}
                height={height}
                handleChangeHeight={this.handleChangeHeight}
                age={age}
                handleChangeAge={this.handleChangeAge}
                dailyActivity={dailyActivity}
                handleChangeDailyActivity={this.handleChangeDailyActivity}
                sliderValue={sliderValue}
                handleChangeSlider={this.handleChangeSlider}
                handleShowResults={this.handleShowResults}
              />
            </LayoutWrapper>
            <CalorieCalculatorNewsletter
              locale={locale}
              handleSubmit={this.handleSubmit}
              error={error}
              email={email}
              handleChangeEmail={this.handleChangeEmail}
            />
          </React.Fragment>
        ) : (
          <CalorieResult
            locale={locale}
            units={units}
            gender={gender}
            weight={weight}
            height={height}
            age={age}
            dailyActivity={dailyActivity}
            sliderValue={sliderValue}
            handleCloseResults={this.handleCloseResults}
          />
        )}
      </React.Fragment>
    )
  }
}

CalorieCalculatorContainer.contextType = LocaleContext
export default CalorieCalculatorContainer
